import {UploadButtonStyles} from './buttons/theme';
import {UnverifiedActionStyles} from './outreachcampaign-views/theme';
import {TestProfileSampleStyle} from './outreachcampaign-views/theme';

export default {
  UploadButtonStyles,
  UnverifiedActionStyles,
  TestProfileSampleStyle,
};
